module.exports = __webpack_public_path__ + "img/195257.50bbb47b.svg";